const PrincessDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M95.99,4.53c0-0.02,0-0.05,0-0.07c0-0.01-0.01-0.02-0.01-0.03c-0.01-0.03-0.02-0.06-0.04-0.1
	c-0.01-0.03-0.03-0.06-0.05-0.08c-0.02-0.03-0.04-0.05-0.07-0.07c-0.02-0.02-0.05-0.05-0.07-0.07c-0.03-0.02-0.05-0.03-0.08-0.05
	c-0.03-0.02-0.06-0.03-0.1-0.04c-0.01,0-0.02-0.01-0.03-0.01c-0.02-0.01-0.04,0-0.07,0C95.44,4.01,95.42,4,95.4,4H4.6
	C4.58,4,4.56,4.01,4.53,4.02c-0.02,0-0.04,0-0.07,0c-0.01,0-0.02,0.01-0.03,0.01C4.4,4.04,4.37,4.06,4.34,4.07
	C4.31,4.09,4.28,4.1,4.26,4.12C4.23,4.14,4.21,4.16,4.18,4.18C4.16,4.21,4.14,4.23,4.12,4.26C4.1,4.28,4.09,4.31,4.07,4.34
	C4.06,4.37,4.04,4.4,4.03,4.44c0,0.01-0.01,0.02-0.01,0.03c-0.01,0.02,0,0.05,0,0.07C4.01,4.56,4,4.58,4,4.6V95.4
	c0,0.02,0.01,0.05,0.01,0.07c0,0.02,0,0.05,0,0.07c0,0.01,0.01,0.02,0.01,0.03c0.01,0.03,0.02,0.06,0.04,0.1
	c0.01,0.03,0.03,0.06,0.05,0.08c0.02,0.03,0.04,0.05,0.07,0.07c0.02,0.02,0.05,0.05,0.07,0.07c0.03,0.02,0.05,0.03,0.08,0.05
	c0.03,0.02,0.06,0.03,0.1,0.04c0.01,0,0.02,0.01,0.03,0.01C4.51,95.99,4.56,96,4.6,96H95.4c0.05,0,0.09-0.01,0.14-0.02
	c0.01,0,0.02-0.01,0.03-0.01c0.03-0.01,0.06-0.02,0.1-0.04c0.03-0.01,0.06-0.03,0.08-0.05c0.03-0.02,0.05-0.04,0.07-0.07
	c0.02-0.02,0.05-0.05,0.07-0.07c0.02-0.03,0.03-0.05,0.05-0.08c0.02-0.03,0.03-0.06,0.04-0.1c0-0.01,0.01-0.02,0.01-0.03
	c0.01-0.02,0-0.05,0-0.07c0-0.02,0.01-0.04,0.01-0.07V4.6C96,4.58,95.99,4.56,95.99,4.53z M31.72,82.9L50,76.14l18.29,6.77H31.72z
	 M68.28,17.1L50,23.86L31.71,17.1H68.28z M82.9,68.28L76.14,50l6.77-18.29V68.28z M69.83,69.83L50,74.88l-19.83-5.05L25.12,50
	l5.05-19.83L50,25.12l19.83,5.05L74.88,50L69.83,69.83z M5.2,7.14L15.89,28.5v43L5.2,92.86V7.14z M17.1,31.72L23.86,50L17.1,68.29
	V31.72z M24.39,47.99l-7.01-18.93l11.54,1.15L24.39,47.99z M24.39,52.01l4.53,17.78l-11.54,1.15L24.39,52.01z M75.61,47.99
	l-4.53-17.78l11.54-1.15L75.61,47.99z M75.61,52.01l7.01,18.93l-11.54-1.15L75.61,52.01z M94.8,92.86L84.11,71.5v-43L94.8,7.14
	V92.86z M83.12,27.8l-12.13,1.21l1.21-12.13L94.05,5.95L83.12,27.8z M69.79,28.93l-17.78-4.53l18.93-7.01L69.79,28.93z M47.99,24.39
	l-17.78,4.53l-1.15-11.54L47.99,24.39z M16.88,27.8L5.95,5.95L27.8,16.88l1.21,12.13L16.88,27.8z M16.88,72.2l12.13-1.21L27.8,83.12
	L5.95,94.05L16.88,72.2z M30.21,71.07l17.78,4.53l-18.93,7.01L30.21,71.07z M52.01,75.61l17.78-4.53l1.15,11.54L52.01,75.61z
	 M83.12,72.2l10.94,21.85L72.2,83.12l-1.21-12.13L83.12,72.2z M92.86,5.2L71.5,15.89h-43L7.14,5.2H92.86z M7.14,94.8L28.5,84.11h43
	L92.86,94.8H7.14z"
      />
    </svg>
  )
}

export default PrincessDiamond
